var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quote-hk02276-overview",on:{"click":_setup.handleClick}},[_c(_setup.ContentBlock)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }